module.exports = __webpack_public_path__ + "static/media/galerija_2019 (29).21787eb1.jpg";